const routes = [
  {
    path: "/ossImgEdit",
    name: "ossImgEdit",
    meta: { title: "首页" },
    component: () => import("@/demo/ossImgEdit.vue"),
  },
];

export default routes;
